
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/heating-and-gas",
      function () {
        return require("private-next-pages/services/heating-and-gas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/heating-and-gas"])
      });
    }
  